import { addQueryArgs } from '@wordpress/url';
import 'nouislider';

const productFilterNode = document.querySelector( '.wcbt-product-filter' );
let query = {};

const wcbtSearch = ( field, action ) => {
	if ( ! productFilterNode ) {
		return;
	}

	query = getParamsOfUrl();

	//Categories
	const categoryNodes = productFilterNode.querySelectorAll( '.category input' );
	[ ...categoryNodes ].map( ( categoryNode ) => {
		categoryNode.addEventListener( 'change', function() {
			updateCategoryQuery();
		} );
	} );

	//Availability
	const availabilityNodes = productFilterNode.querySelectorAll( '.availability input' );
	[ ...availabilityNodes ].map( ( availabilityNode ) => {
		availabilityNode.addEventListener( 'change', function() {
			updateAvailabilityQuery();
		} );
	} );

	//Rating
	const ratingNodes = productFilterNode.querySelectorAll( '.rating input' );
	[ ...ratingNodes ].map( ( ratingNode ) => {
		ratingNode.addEventListener( 'change', function() {
			updateRatingQuery();
		} );
	} );

	//Price
	const priceWrapper = document.querySelector( '.wcbt-product-filter .price.wrapper' );
	if ( priceWrapper ) {
		const priceSliderNode = priceWrapper.querySelector( '#search-price' );

		priceSliderNode.noUiSlider.on( 'change', function( values, handle, unencoded ) {
			query.min_price = values[ 0 ];
			query.max_price = values[ 1 ];

			redirect();
		} );
	}

	//Attribute
	const attributeNodes = document.querySelectorAll( '.wcbt-product-filter .attribute.wrapper' );
	[ ...attributeNodes ].map( ( attributeNode ) => {
		const taxonomy = attributeNode.getAttribute( 'data-taxonomy' );
		const inputNodes = attributeNode.querySelectorAll( 'input' );

		[ ...inputNodes ].map( ( inputNode ) => {
			inputNode.addEventListener( 'change', function() {
				updateAttributeQuery( taxonomy );
			} );
		} );
	} );

	removeSelection();
	clearAllSelection();
};

const removeSelection = () => {
	const listItemNodes = document.querySelectorAll( '.wcbt-product-filter-selection li' );

	[ ...listItemNodes ].map( ( listItem ) => {
		const removeNode = listItem.querySelector( 'span.remove' );

		removeNode.addEventListener( 'click', function( event ) {
			const field = listItem.getAttribute( 'data-field' );
			switch ( field ) {
			case 'category':
				updateCategoryQuery( listItem.getAttribute( 'data-value' ) );
				break;
			case 'availability':
				updateAvailabilityQuery( listItem.getAttribute( 'data-value' ) );
				break;
			case 'rating':
				updateRatingQuery( listItem.getAttribute( 'data-value' ) );
				break;
			case 'price':
				if ( query.hasOwnProperty( 'min_price' ) ) {
					delete query.min_price;
				}
				if ( query.hasOwnProperty( 'max_price' ) ) {
					delete query.max_price;
				}
				redirect();
				break;
			case 'attribute':
				const taxonomy = listItem.getAttribute( 'data-attribute-type' );
				updateAttributeQuery( taxonomy, listItem.getAttribute( 'data-value' ) );
				break;
			default:
				break;
			}
		} );
	} );
};

const clearAllSelection = () => {
	const clearBtnNodes = document.querySelectorAll( '.wcbt-product-filter-selection.wrapper button' );

	[ ...clearBtnNodes ].map( ( clearBtnNode ) => {
		clearBtnNode.addEventListener( 'click', function() {
			if ( query.hasOwnProperty( 'min_price' ) ) {
				delete query.min_price;
			}
			if ( query.hasOwnProperty( 'max_price' ) ) {
				delete query.max_price;
			}

			if ( query.hasOwnProperty( 'availability' ) ) {
				delete query.availability;
			}

			if ( query.hasOwnProperty( 'category' ) ) {
				delete query.category;
			}

			if ( query.hasOwnProperty( 'rating' ) ) {
				delete query.rating;
			}

			const attributeNodes = document.querySelectorAll( '.wcbt-product-filter .attribute.wrapper' );
			[ ...attributeNodes ].map( ( attributeNode ) => {
				const taxonomy = attributeNode.getAttribute( 'data-taxonomy' );
				if ( query.hasOwnProperty( taxonomy ) ) {
					delete query[ taxonomy ];
				}
			} );

			redirect();
		} );
	} );
};

const redirect = () => {
	const url = WCBT_PRODUCT_FILTER.current_page_url || document.location.origin + document.location.pathname;
	if ( query.hasOwnProperty( 'product-page' ) ) {
		delete query[ 'product-page' ];
	}

	document.location.href = addQueryArgs( url, query );
};

const getParamsOfUrl = () => {
	const urlParams = new URLSearchParams( location.search );

	const queryParams = {};
	for ( const [ key, value ] of urlParams ) {
		queryParams[ key ] = value;
	}

	return queryParams;
};

const updateCategoryQuery = ( exclude = '' ) => {
	if ( query.hasOwnProperty( 'category' ) ) {
		delete query.category;
	}

	const checkedCategoryNodes = productFilterNode.querySelectorAll( '.category input:checked' );
	const categoryParams = [];
	[ ...checkedCategoryNodes ].map( ( checkedCategoryNode ) => {
		if ( checkedCategoryNode.value !== exclude ) {
			categoryParams.push( checkedCategoryNode.value );
		}
	} );

	if ( categoryParams.length ) {
		query.category = encodeURIComponent( JSON.stringify( categoryParams ) );
	}

	redirect();
};

const updateAvailabilityQuery = ( exclude = '' ) => {
	if ( query.hasOwnProperty( 'availability' ) ) {
		delete query.availability;
	}

	const checkedAvailabilityNodes = productFilterNode.querySelectorAll( '.availability input:checked' );
	const availabilityParams = [];
	[ ...checkedAvailabilityNodes ].map( ( checkedAvailabilityNode ) => {
		if ( checkedAvailabilityNode.value !== exclude ) {
			availabilityParams.push( checkedAvailabilityNode.value );
		}
	} );

	if ( availabilityParams.length ) {
		query.availability = encodeURIComponent( JSON.stringify( availabilityParams ) );
	}
	redirect();
};

const updateRatingQuery = ( exclude = '' ) => {
	if ( query.hasOwnProperty( 'rating' ) ) {
		delete query.rating;
	}

	const checkedRatingNodes = productFilterNode.querySelectorAll( '.rating input:checked' );
	const ratingParams = [];
	[ ...checkedRatingNodes ].map( ( checkedRatingNode ) => {
		if ( checkedRatingNode.value !== exclude ) {
			ratingParams.push( checkedRatingNode.value );
		}
	} );

	if ( ratingParams.length ) {
		query.rating = encodeURIComponent( JSON.stringify( ratingParams ) );
	}
	redirect();
};

const updateAttributeQuery = ( taxonomy, exclude = '' ) => {
	if ( query.hasOwnProperty( taxonomy ) ) {
		delete query[ taxonomy ];
	}

	const checkedInputNodes = document.querySelectorAll( `.wcbt-product-filter .attribute[data-taxonomy="${ taxonomy }"] input:checked` );
	const attributeParams = [];
	[ ...checkedInputNodes ].map( ( checkedInputNode ) => {
		if ( checkedInputNode.value !== exclude ) {
			attributeParams.push( checkedInputNode.value );
		}
	} );

	if ( attributeParams.length ) {
		query[ taxonomy ] = encodeURIComponent( JSON.stringify( attributeParams ) );
	}
	redirect();
};

export default wcbtSearch;
